/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{neverReached as o}from"../../../../../../../core/compilerUtils.js";import{packFloatRGBA as e}from"../../../../../../../core/floatRGBA.js";import has from"../../../../../../../core/has.js";import{DecodeSymbolColor as r}from"./DecodeSymbolColor.glsl.js";import{ShaderOutput as t}from"../../../../core/shaderLibrary/ShaderOutput.js";import{RgbaFloatEncoding as n}from"../../../../core/shaderLibrary/util/RgbaFloatEncoding.glsl.js";import{Float4DrawUniform as a}from"../../../../core/shaderModules/Float4DrawUniform.js";import{IntegerDrawUniform as d}from"../../../../core/shaderModules/IntegerDrawUniform.js";import{glsl as l}from"../../../../core/shaderModules/interfaces.js";import{Texture2DDrawUniform as c}from"../../../../core/shaderModules/Texture2DDrawUniform.js";import{VertexAttribute as i}from"../../../../lib/VertexAttribute.js";var s;!function(o){o[o.Uniform=0]="Uniform",o[o.Varying=1]="Varying",o[o.COUNT=2]="COUNT"}(s||(s={}));const x=429496.7296;function C(o,r){e(o/x*.5+.5,r)}function m(e,r){switch(r.componentData){case s.Varying:return f(e,r);case s.Uniform:return u(e,r);case s.COUNT:return;default:o(r.componentData)}}function f(o,e){const{vertex:a,fragment:d}=o;a.include(n),a.uniforms.add(new c("componentColorTex",(o=>o.componentParameters.texture.texture))),o.attributes.add(i.COMPONENTINDEX,"float"),o.varyings.add("vExternalColorMixMode","mediump float"),o.varyings.add("vExternalColor","vec4");const s=e.output===t.ObjectAndLayerIdColor;s&&o.varyings.add("vObjectAndLayerIdColor","vec4"),o.include(r),a.constants.add("elevationScale","float",2*x),a.constants.add("stride","float",has("enable-feature:objectAndLayerId-rendering")?3:2),a.code.add(l`vec2 getComponentTextureCoordinates(float componentIndex, float typeOffset) {
float index = componentIndex * stride + typeOffset;
float texSize = float(textureSize(componentColorTex, 0).x);
float coordX = mod(index, texSize);
float coordY = floor(index / texSize);
return vec2(coordX, coordY) + 0.5;
}`),a.code.add(l`
  vec4 _readComponentColor() {
    vec2 textureCoordinates = getComponentTextureCoordinates(componentIndex, 0.0);

    return texelFetch(componentColorTex, ivec2(textureCoordinates), 0);
   }

   float readElevationOffset() {
    vec2 textureCoordinates = getComponentTextureCoordinates(componentIndex, 1.0);

    vec4 encodedElevation = texelFetch(componentColorTex, ivec2(textureCoordinates), 0);
    return (rgba2float(encodedElevation) - 0.5) * elevationScale;
  }

  ${s?l`
          void forwardObjectAndLayerIdColor() {
            vec2 textureCoordinates = getComponentTextureCoordinates(componentIndex, 2.0);

            vObjectAndLayerIdColor = texelFetch(componentColorTex, ivec2(textureCoordinates), 0);
          }`:l`void forwardObjectAndLayerIdColor() {}`}

  vec4 forwardExternalColor(out bool castShadows) {
    vec4 componentColor = _readComponentColor() * 255.0;

    float shadowFlag = mod(componentColor.b * 255.0, 2.0);
    componentColor.b -= shadowFlag;
    castShadows = shadowFlag >= 1.0;

    int decodedColorMixMode;
    vExternalColor = decodeSymbolColor(componentColor, decodedColorMixMode) * 0.003921568627451; // = 1/255;
    vExternalColorMixMode = float(decodedColorMixMode) + 0.5; // add 0.5 to avoid interpolation artifacts

    return vExternalColor;
  }
`),d.code.add(l`
  void readExternalColor(out vec4 externalColor, out int externalColorMixMode) {
    externalColor = vExternalColor;
    externalColorMixMode = int(vExternalColorMixMode);
  }

  void outputObjectAndLayerIdColor() {
     ${s?l`fragColor = vObjectAndLayerIdColor;`:""}
  }
`)}function u(o,e){const{vertex:r,fragment:n}=o;r.uniforms.add(new a("externalColor",(o=>o.componentParameters.externalColor))),n.uniforms.add(new d("externalColorMixMode",(o=>o.componentParameters.externalColorMixMode))),o.varyings.add("vExternalColor","vec4"),r.code.add(l`float readElevationOffset() {
return 0.0;
}
void forwardObjectAndLayerIdColor() {}
vec4 forwardExternalColor(out bool castShadows) {
vExternalColor = externalColor;
castShadows = true;
return externalColor;
}`);const c=e.output===t.ObjectAndLayerIdColor;n.code.add(l`
  void readExternalColor(out vec4 color, out int colorMixMode) {
    color = vExternalColor;
    colorMixMode = externalColorMixMode;
  }

  void outputObjectAndLayerIdColor() {
    ${c?l`fragColor = vec4(0,0,0,0);`:""}
 }
`)}export{m as ComponentData,s as ComponentDataType,C as encodeElevationOffset,x as maxElevationOffset};
